module.exports = __webpack_public_path__ + "img/Diamond-Aesthetics-Academy-Logo.80d7ba30.png";